"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var hostName = window.location.hostname;
var Appdefs = window.cccisd.appDefs;
var Footer = function Footer(props) {
  var _Appdefs$app, _Appdefs$app$footer, _Appdefs$app2, _Appdefs$app2$footer, _Appdefs$app3, _Appdefs$app3$footer;
  var copyrightYear = props.copyrightYear || (Appdefs === null || Appdefs === void 0 ? void 0 : (_Appdefs$app = Appdefs.app) === null || _Appdefs$app === void 0 ? void 0 : (_Appdefs$app$footer = _Appdefs$app.footer) === null || _Appdefs$app$footer === void 0 ? void 0 : _Appdefs$app$footer.copyrightYear) || new Date().getFullYear();
  var copyrightAttribution = props.copyrightAttribution || (Appdefs === null || Appdefs === void 0 ? void 0 : (_Appdefs$app2 = Appdefs.app) === null || _Appdefs$app2 === void 0 ? void 0 : (_Appdefs$app2$footer = _Appdefs$app2.footer) === null || _Appdefs$app2$footer === void 0 ? void 0 : _Appdefs$app2$footer.copyrightAttribution) || '3C Institute';
  var grantAttribution = props.grantAttribution || (Appdefs === null || Appdefs === void 0 ? void 0 : (_Appdefs$app3 = Appdefs.app) === null || _Appdefs$app3 === void 0 ? void 0 : (_Appdefs$app3$footer = _Appdefs$app3.footer) === null || _Appdefs$app3$footer === void 0 ? void 0 : _Appdefs$app3$footer.grantAttribution);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].footer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    style: grantAttribution ? {
      marginBottom: 4
    } : {
      marginBottom: 0
    }
  }, "Software developed by", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "//www.3cisd.com?r=".concat(hostName),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "3C Institute."), ' ', "\xA9 ", copyrightYear, " ", copyrightAttribution, ", All Rights Reserved."), grantAttribution && /*#__PURE__*/_react["default"].createElement("small", null, grantAttribution)), props.showPolicyLinks && /*#__PURE__*/_react["default"].createElement("div", null, props.showContactUsLink && /*#__PURE__*/_react["default"].createElement("a", {
    href: "//www.3cisd.com/?r=".concat(hostName, "/#ccc-lets-talk"),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Contact Us"), props.showTermsLink && /*#__PURE__*/_react["default"].createElement("a", {
    href: "//www.3cisd.com/terms-of-use/?r=".concat(hostName),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Terms of Use"), props.showPolicyLink && /*#__PURE__*/_react["default"].createElement("a", {
    href: "//www.3cisd.com/privacy-policy/?r=".concat(hostName),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Privacy Policy")))));
};
Footer.propTypes = {
  className: _propTypes["default"].string,
  showPolicyLinks: _propTypes["default"].bool,
  copyrightAttribution: _propTypes["default"].string,
  copyrightYear: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  grantAttribution: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  showContactUsLink: _propTypes["default"].bool,
  showTermsLink: _propTypes["default"].bool,
  showPolicyLink: _propTypes["default"].bool
};
Footer.defaultProps = {
  className: 'container',
  showPolicyLinks: true,
  showContactUsLink: true,
  showTermsLink: true,
  showPolicyLink: true
};
var _default = Footer;
exports["default"] = _default;